import classnames from 'classnames'
import React from 'react'
import { Link } from 'react-router-dom'

export default function Argument(props) {
  const { theme, argument, imageLoaded, handleSelect, handleImageLoad } = props

  const className = classnames(theme.argument, {
    [theme.imageLoaded]: imageLoaded
  })

  return (
    <div className={className} onClick={handleSelect}>
      <Link to={`/argument/${argument.id}/builder`}>
        <img
            alt={argument.text}
            className={theme.argumentImage}
            src={argument.imgUrl}
            onLoad={handleImageLoad} />
      </Link>

      <div className={theme.argumentText}>
        {argument.text}
      </div>
    </div>
  )
}



// WEBPACK FOOTER //
// ./client/modules/debate/components/Question/Argument/Argument.js